module.exports = __webpack_public_path__ + "static/media/29BDOS5.ec1fe490.jpg";